module.exports = __webpack_public_path__ + "static/media/cocorobo_wechat_qrcode.730a4321.png";